const FETCH_FIRM_INFO="FETCH_FIRM_INFO";

const ActionType={
    FETCH_FIRM_INFO,
}

export default ActionType;